import { createContext, useContext } from "react";
    
    export const FetchAPIContext = createContext({
      data: undefined,
      isLoading: false,
      setApiUrl: () => {}
    });
    
    export const useFetchAPIContext = () => useContext(FetchAPIContext);